export default __webpack_public_path__ + "static/media/PeeCeeB@2x.653ccefa.png";